var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.qrText)?_c('v-card',{staticClass:"mt-10",staticStyle:{"text-align":"center"},attrs:{"outlined":""}},[_c('div',{staticClass:"mt-5"},[_c('qrcode',{attrs:{"size":_vm.size,"cls":_vm.qrCls,"value":_vm.qrText}})],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }